import { FunctionComponent } from 'react';
import Table from './Table';

interface Props {
  logs: string[];
}

const Logs: FunctionComponent<Props> = ({ logs }) => {
  return (
    <>
      {logs.map((log, logIndex) => {
        if (log.startsWith('DEV: ')) {
          const { headers, body } = JSON.parse(log.replace('DEV: ', ''));
          return <Table key={logIndex} headers={headers} data={body} />;
        }

        const logColor = log.startsWith('(SQL error)') ? 'text-platzi-error' : 'text-primary-light';

        return (
          <p
            key={logIndex}
            className={`text-sm w-full relative py-2 px-4 flex space-x-2 items-center ${logColor}`}
          >
            <code>{log}</code>
          </p>
        );
      })}
    </>
  );
};

export default Logs;
